<template>
  <div class="as-players">
    <div
      class="as-line-up-colunm"
      :class="{
        'as-line-up-colunm-sm': screenWidth < 370,
      }"
    >
      <div class="as-line-up-colunm-item">
        <div class="as-line-up-item as-line-up-item-team as-line-up-item-home">
          <div class="as-match__team">
            <img
              class="as-match__team-logo"
              :src="
                getImgUrlBySport(
                  'team',
                  lineups?.coach?.home ? lineups.coach?.home?.team_id : match.home_team_id
                )
              "
            />
            <div class="as-match__team-name">
              {{ lineups?.coach?.home ? lineups.coach?.home?.name : match.home_team.name }}

            </div>
          </div>
        </div>
        <div
          v-for="(player, key) in startingPlayers.home"
          :key="key"
          class="as-line-up-item as-line-up-item-home"
          :class="{
            'as-line-up-item-last':
              `${key}` === `${startingPlayers.home.length - 1}`,
          }"
        >
          <div class="as-player as-player-row">
            <a :href="getLinkPlayerDetail(player)" class="as-player-name">
              <img
                class="as-player-logo"
                :src="getImgUrlBySport('player', player.id)"
              />
              <div class="as-player-shirt-name">
                <span>{{ player.name }}</span>
                <span class="as-shirt-number">
                  {{ player.shirt_number ? player.shirt_number : "" }}-{{
                    player.position
                  }}
                </span>
              </div>
            </a>

            <div
              class="as-d-flex as-align-items-center as-gap-4"
            >
              <div
                v-if="player.incidents.length"
                v-for="(incident, incidentKey) in player.incidents"
                :key="incidentKey"
                class="as-player-incident"
              >
                <component
                  v-if="getIncidentIcon(player, incident, isSubstituted)"
                  :is="getIncidentIcon(player, incident, isSubstituted)"
                />
                <span v-if="[1, 3, 9].includes(incident.type)" class="as-time">{{ incident.time }}'</span>
              </div>
              <div
                v-if="player.rating !== '0.0'"
                class="as-player-rating"
                :style="{
                  background: formatRateColor(parseFloat(player.rating)),
                }"
              >
                {{ player.rating }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="as-line-up-colunm-item">
        <div class="as-line-up-item as-line-up-item-team as-line-up-item-home">
          <div class="as-match__team">
            <img
              class="as-match__team-logo"
              :src="
                getImgUrlBySport(
                  'team',
                  lineups?.coach?.away ? lineups.coach?.away?.team_id : match.away_team_id
                )
              "
            />
            <div class="as-match__team-name">
              {{ lineups?.coach?.away ? lineups.coach?.away?.name : match.away_team.name }}
            </div>
          </div>
        </div>
        <div
          v-for="(player, key) in startingPlayers.away"
          :key="key"
          class="as-line-up-item as-line-up-item-away"
          :class="{
            'as-line-up-item-last':
              `${key}` === `${startingPlayers.away.length - 1}`,
          }"
        >
          <div class="as-player as-player-row">
            <a :href="getLinkPlayerDetail(player)" class="as-player-name">
              <img
                class="as-player-logo"
                :src="getImgUrlBySport('player', player.id)"
              />
              <div class="as-player-shirt-name">
                <span>{{ player.name }}</span>
                <span class="as-shirt-number">
                  {{ player.shirt_number ? player.shirt_number : "" }}-{{
                    player.position
                  }}
                </span>
              </div>
            </a>

            <div
              class="as-d-flex as-align-items-center as-gap-4"
            >
              <div
                v-if="player.incidents.length"
                v-for="(incident, incidentKey) in player.incidents"
                :key="incidentKey"
                class="as-player-incident"
              >
                <component
                  v-if="getIncidentIcon(player, incident, isSubstituted)"
                  :is="getIncidentIcon(player, incident, isSubstituted)"
                />
                <span v-if="[1, 3, 9].includes(incident.type)" class="as-time">{{ incident.time }}'</span>
              </div>
              <div
                v-if="player.rating !== '0.0'"
                class="as-player-rating"
                :style="{
                  background: formatRateColor(parseFloat(player.rating)),
                }"
              >
                {{ player.rating }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <NoData
      v-if="!startingPlayers.home.length && !startingPlayers.away.length"
      title="Không có dữ liệu"
      modifyClass="as-h-auto"
    />
  </div>
</template>

<script setup lang="ts">
import { defineProps, computed } from "vue";
import type { ILineups, IMatch, IStartingPlayers } from "~src/interfaces";
import { formatRateColor, getIncidentIcon } from "~src/helpers";
import NoData from "~src/components/NoData.vue";
import { useMatchDetailStore } from "~src/stores/MatchDetailStore";
const matchDetailStore = useMatchDetailStore();

interface IProps {
  lineups: ILineups;
  match: IMatch;
  startingPlayers: IStartingPlayers;
  isSubstituted: boolean;
}

withDefaults(defineProps<IProps>(), {
  isSubstituted: false
});

const screenWidth = computed(() => matchDetailStore.getScreenWidth);
</script>

<script lang="ts">
export default {};
</script>
